module.exports = __webpack_public_path__ + "img/Campus.5fd9ee00.png";